import {Container, Row, Card, Col} from 'react-bootstrap';
import Gerardo from '../../images/gcastillo.png'
import Pamela from '../../images/pguevara.png'
import Claudio from '../../images/cmuller.png'
import Carla from '../../images/carla.png'
import Cristian from '../../images/cneira.png'
import LogoUdec from '../../images/escudo_udec.png'
import LogoFarmacia from '../../images/farmacia.png'
import LogoIng from '../../images/logo_ing.png'
import Logo from '../../images/logo_confondo.png'
import { AiFillLinkedin, AiOutlineLink } from 'react-icons/ai'
import '../../index.css'

export default function MyAbout() {
  return <div>
        <div class="row text-center d-flex justify-content-around align-items-center marginAlt2">
        <div style={{width:'auto', display:'flex', justifyContent:'center', marginRight:'auto', marginLeft:'auto'}}>
          <Col>
            <Row className='d-flex justify-content-around align-items-center'>
            <img style={{height:'150px', width:'auto' }} src={Logo} alt=""/>
            </Row>
            <Row className='d-flex justify-content-around align-items-center'>
            <h2 class="text-center mt-4">Sobre nosotros</h2>
            </Row>
          </Col>
        </div>
        </div>
        <Container className='Container2'>
          <Row className='d-flex justify-content-around align-items-center py-5'>
            <Col xs='6' sm='6' md='6' lg='6'>
            <Row>
                    <h3>Misión</h3>
                    <p>
                    Nuestra misión es hacer que la búsqueda de información sobre toxicología clinica sea mucho más fácil y que esta se pueda encontrar en un único lugar.
                    </p>
              </Row>
            </Col>
            <Col xs='6' sm='6' md='6' lg='6'>

              <Row>
                    <h3>Objetivo</h3>
                    <p>
                    Facilitar el acceso a la información sobre el manejo de las intoxicaciones agudas más recurrentes en Chile mediante una interfaz intuitiva y de fácil acceso.
                    </p>
              </Row>
              </Col>

          </Row>
      </Container>
    

      <div className='hline' style={{marginTop:'10%'}}></div>


      <Container>   
      <div class="row text-center d-flex justify-content-around align-items-center" style={{marginTop:'10%'}}>
      <Row className='d-flex justify-content-around align-items-center'>
            <h4>Conoce al equipo encargado del proyecto:</h4>
            </Row>
        <Card border="info" style={{ width: '22rem', marginTop:'50px'}}>
        <Card.Img variant="top" src={Pamela} />
        <Card.Body>
          <Card.Title>Pamela Guevara</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">Tutora</Card.Subtitle>
          <Card.Text>
          Ingeniera Civil Electrónica, Doctora en Física, con experiencia en proyectos multidisciplinarios y desarrollo de aplicaciones para el área de la salud.
          </Card.Text>
          <a className="textlink" href="https://www.linkedin.com/in/pamela-guevara/"><AiFillLinkedin style={{ fontSize: '30px', color: '#28242c' }}/></a>
        </Card.Body>
        </Card>

      <Card border="info" style={{ width: '22rem', marginTop:'50px'}}>
        <Card.Img variant="top" src={Claudio} />
        <Card.Body>
          <Card.Title>Claudio Müller</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">Director del Proyecto</Card.Subtitle>
          <Card.Text>
          Químico Farmacéutico y Doctor en Toxicología con amplia experiencia en Toxicología clínica, analítica-forense y ocupacional.
          </Card.Text>
          <a className="textlink" href="https://dpfarmacia-udec.cl/claudio-muller/"><AiOutlineLink style={{ fontSize: '30px', color: '#28242c' }}/></a>
      </Card.Body>
      </Card>

      <Card border="info" style={{ width: '22rem', marginTop:'50px'}}>
        <Card.Img variant="top" src={Gerardo} />
        <Card.Body>
          <Card.Title>Gerardo Castillo</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">Desarollador</Card.Subtitle>
          <Card.Text>
          Memorista de Ingeniería Civil Biomédica en la Universidad de Concepción. Encargado del desarrollo Web del proyecto.
          </Card.Text>
          <a className="textlink" href="https://www.linkedin.com/in/geracastillo/"><AiFillLinkedin style={{ fontSize: '30px', color: '#28242c' }}/></a>
      </Card.Body>
      </Card>

      <Card border="info" style={{ width: '22rem', marginTop:'50px'}}>
        <Card.Img variant="top" src={Carla} />
        <Card.Body>
          <Card.Title>Carla González</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">Base de datos</Card.Subtitle>
          <Card.Text>
          Químico Farmacéutico Hospital Las Higueras. Encargada de reunir y validar la información sobre Tóxicos de la base de datos.
          </Card.Text>
          <a className="textlink" href="https://www.linkedin.com/in/carla-gonzález-norambuena-870b2020b/"><AiFillLinkedin style={{ fontSize: '30px', color: '#28242c' }}/></a>
      </Card.Body>
      </Card>

      <Card border="info" style={{ width: '22rem', marginTop:'50px'}}>
        <Card.Img variant="top" src={Cristian} />
        <Card.Body>
          <Card.Title>Cristian Neira</Card.Title>
          <Card.Subtitle className="mb-2 text-muted">Desarrollo</Card.Subtitle>
          <Card.Text>
          Ingeniero Civil Electrónico, Diplomado en Innovación y Arquitecto Cloud, labores de apoyo en desarrollo Web del proyecto.
          </Card.Text>
          <a className="textlink" href="https://www.linkedin.com/in/cristian-neira-silva-97a5881a/"><AiFillLinkedin style={{ fontSize: '30px', color: '#28242c' }}/></a>
      </Card.Body>
      </Card>

      </div>
    </Container>

    {/* <div className='hline'></div> */}
    {/* Linea horizontal  */}

    {/* <Container>
      <div class="row text-center d-flex justify-content-around align-items-center py-5">
    <Card className="text-center" style={{ width: '50rem' }}>
      <Card.Header></Card.Header>
      <Card.Body>
      <GoBriefcase style={{ fontSize: '50px', color: '#28242c' }}/>
        <Card.Title>Misión</Card.Title>
        <Card.Text>
        Este proyecto de WebApp tiene la finalidad de facilitar el acceso a la información sobre el manejo de las intoxicaciones agudas más recurrentes en Chile mediante una interfaz intuitiva y de fácil acceso.
        </Card.Text>
      </Card.Body>
    </Card>
    </div>
    </Container> */}
    {/* {Una card con la misión (ejemplo)} */}

  
    
    <div className='hline' style={{marginTop:'5rem'}}></div>
    <Container>
        <Row style={{marginTop:'5rem'}}>
      <div style={{width:'auto', display:'flex', justifyContent:'center', marginRight:'auto', marginLeft:'auto'}}>
                    <img style={{height:'100px', }} src={LogoUdec} alt=""/>
      </div>
      <div style={{width:'auto', display:'flex', justifyContent:'center', marginRight:'auto', marginLeft:'auto'}}>
                    <img style={{height:'100px', }} src={LogoFarmacia} alt=""/>
      </div>
      <div style={{width:'auto', display:'flex', justifyContent:'center', marginRight:'auto', marginLeft:'auto'}}>
                    <img style={{height:'100px', }} src={LogoIng} alt=""/>
      </div>
      <p></p>
      <p></p>
      <p></p>
        </Row>
        <Row style={{marginBottom:'5rem', marginTop:'5%'}}>
        <div style={{width:'auto', display:'flex', justifyContent:'center', marginRight:'auto', marginLeft:'auto'}}>
      <p><i>Proyecto impulsado por la Facultad de Farmacia de la Universidad de Concepción con participación de la Facultad de Ingeniería.</i></p>
      </div>
        </Row>

    </Container>


   </div>;
  }